import './index.css';
import * as React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { AuthProvider, useAuthCtx } from '@/auth/auth-context';
import { routeTree } from './routeTree.gen';

const qc = new QueryClient({ defaultOptions: { queries: { refetchOnWindowFocus: false } } });

const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  context: { user: null as ReturnType<typeof useAuthCtx>['user'] },
});

declare module '@tanstack/react-router' {
  interface Register { router: typeof router }
}

function App() {
  const auth = useAuthCtx();
  if (auth.isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <p className="text-sm text-muted-foreground">Loading…</p>
      </div>
    );
  }
  return <RouterProvider router={router} context={{ user: auth.user }} />;
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={qc}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
